<template>
    <div class="rcclQN__experience" ref="experienceBanner">
        <div class="rcclQN__experienceCon">
            <p class="experienceCon__title">这里有超凡的度假体验</p>
            <div class="experienceCon__menus" ref="experienceMenu">
                <div class="experienceCon__mainCon">
                    <div>
                        <div class="menuItem--body1 " 
                        v-for="(category, i) in cruiseRoyalExperienceItems"
                        :key="('categoryMenu_' + i)" @click="onCategoryClick(category.category)"
                        :class="{ body1Active: currentCategory==category.category}"
                        >
                            <div class="menuItem--menu">
                                <img :alt="category.category" class="img2" style="position: absolute; left: 0; height: 100%;"
                                    :src="getCategoryIcon(category.category)[0]">
                            </div>
                            <div class="menuItem--main" :class="{ active: currentCategory==category.category}">
                                <div class="menuItem--mainCon">
                                    <div class="menuItem--mainPic">
                                        <img :alt="category.category" :src="getCategoryIcon(category.category)[1]"
                                            class="unactiveImg">
                                        <img :alt="category.category" :src="getCategoryIcon(category.category)[2]"
                                            class="activeImg">
                                    </div>
                                    <p class="menuItem--mainTxtB">{{category.category}}</p>
                                    <p class="menuItem--mainTxtS">{{category.categoryDescription}}</p>
                                </div>
                            </div>
                            <div class="menuItem--border"><img
                                    src="https://resource.rcclchina.com.cn/rcclQN/image/experienceBg.png"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="poiStart content_eight" v-show="isMenuFixed">
                <div class="poi_nav_box">
                    <div class="poi_nav">
                        <table>
                            <tbody>
                                <tr>
                                    <td  v-for="(category, i) in cruiseRoyalExperienceItems"
                        :key="('categoryMenuFix_' + i)" @click="onCategoryClick(category.category)"
                        :class="{ current: currentCategory==category.category}">{{category.category}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="experienceCon__menuItem" ref="experiencePart">
                <ShipExperienceGroup 
                    v-for="(category, i) in categories" :key="('itemGroup_' + i)"
                    v-show="currentCategory==category"
                    :items="getItemList(category)"
                    :subCategories="getSubCategories(category)"
                    :category="category"
                    :onItemClick="showExperiencePopup"
                    :isMenuFixed="isMenuFixed"
                    :scrollToStart="scrollToStart"
                />

                <ShipExperiencePopup 
                    :item="targetItem"
                    :ships="ships"
                    :itemList="productModel"
                    v-if="isShowExperiencePopup"
                    :isShow="isShowExperiencePopup"
                    :onClose="closeExperiencePopup"
                />
            </div>
        </div>
    </div>
</template>


<script>
const ShipExperienceGroup = () => import('@/components/Ship/ShipExperienceGroup')
const ShipExperiencePopup = () => import('@/components/Ship/ShipExperiencePopup')
export default {
    name: "ShipExperience",
    components: {
        ShipExperienceGroup,
        ShipExperiencePopup
    },
    props: {
        productModel: {
            type: Array,
        },
        cruiseRoyalExperienceItems: {
            type: Array,
        },
        itemViewModels: {
            type: Array
        },
        ships: {
            type: Array
        },
        initCategory: {
            type: String,
            default () {
                return ""
            }
        }
    },
    data () {
        return {
            currentCategory: this.initCategory || "超凡美食",
            // 点击选中的item
            targetItem: {},
            isShowExperiencePopup: false,
            isMenuFixed: false
        }
    },
    beforeMount () {
        window.addEventListener("scroll", this.menuFixedHandler)
    },
    beforeDestroy () {
        window.removeEventListener("scroll", this.menuFixedHandler)
    },
    methods: {
        getItemList (category) {
            return this.productModel.filter(r=>r.category==category)
        },
        getBanner (category) {
            return this.cruiseRoyalExperienceItems.find(r=>r.category == category) || {}
        },
        getSubCategories (category) {
            switch (category) {
                case '超凡美食': return ["免费餐厅", "收费餐厅", "酒吧", "其他餐饮服务"]
                case '超凡客房': return ["套房", "阳台房", "海景房", "内舱房"]
                case '超凡活动': return ["招牌演出", "休闲娱乐", "激情运动", "互动课程"]
                case '超凡童趣': return ["海上历奇", "梦工厂", "儿童游乐"]
                default: return ['']
            }
        },
        getCategoryIcon (category) {
            switch (category) {
                case '超凡美食': 
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg1.png'
                    ,'https://resource.rcclchina.com.cn/shipDetail/Food.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/FoodHover.png']
                case '超凡客房': 
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg2.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/guestRoom.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/guestRoomHover.png']
                case '超凡活动':
                    return ['https://resource.rcclchina.com.cn/QN%E7%BE%8E%E9%A3%9F/%E8%B6%85%E5%87%A1%E6%B4%BB%E5%8A%A8%20(1).jpg'
                    , 'https://resource.rcclchina.com.cn/shipDetail/entertainments.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/entertainmentsHover.png']
                case '超凡购物':
                    return ['https://resource.rcclchina.com.cn/QN%E7%BE%8E%E9%A3%9F/%E8%B6%85%E5%87%A1%E8%B4%AD%E7%89%A9%20(1).jpg'
                    , 'https://resource.rcclchina.com.cn/shipDetail/shopping.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/shoppingHover.png']
                case '超凡童趣':
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg7.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/childimg.png'
                    , 'https://resource.rcclchina.com.cn/shipDetail/childimgHover.png']
                case '超凡设施':
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/facitilies143x273.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/facitiliesimg3.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/facitiliesimg4.png']
                case '超凡科技':
                    return ['https://resource.rcclchina.com.cn/rcclQN/image/shadowimg4.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/technology.png'
                    , 'https://resource.rcclchina.com.cn/rcclQN/image/technologyHover.png']
                default:
                    return ['', '', '']
            }
        },
        showExperiencePopup (item) {
            const itemViewModel = this.itemViewModels.find(r=>r.id == item.id)
            if (!itemViewModel) {
                return
            }
            this.targetItem = itemViewModel
            this.targetItem.vrUrl = item.vrUrl
            this.isShowExperiencePopup = true
          console.log('targetItem',this.targetItem)
        },
        closeExperiencePopup () {
            this.targetItem = {}
            this.isShowExperiencePopup = false
        },
        menuFixedHandler () {
            const scrollTop = window.scrollY
            const experienceMenu = this.$refs.experienceMenu
            const targetTop = experienceMenu.offsetTop + experienceMenu.offsetHeight / 2 
            if (scrollTop >= targetTop) {
                this.isMenuFixed = true
            } else {
                this.isMenuFixed = false
            }
        },
        onCategoryClick (category) {
            this.currentCategory = category
            this.scrollToStart()
            this.$emit('onCategoryChange', category)
        },
        //页面滚动至Item开始的地方
        scrollToStart () {
            // const scrollTop = window.scrollY
            const experienceMenu = this.$refs.experienceMenu
            const targetTop = experienceMenu.offsetTop + experienceMenu.offsetHeight - 80
            window.scroll({
                top: targetTop,
                behavior: "smooth"
            })
        },
        
    },
    computed: {
        categories () {
            return this.cruiseRoyalExperienceItems.map(r=>r.category)
        }
    },
    watch: {
        initCategory (newValue) {
            this.currentCategory = newValue
        }
    }
}
</script>

<style lang="less" scoped>
.rcclQN__experience {
    width: 100%;
    padding-top: 1px;
    background: #f0f0f0;

    .experienceCon__title {
        font-size: 36px;
        font-weight: bold;
        color: #000f57;
        text-align: center;
    }

    .experienceCon__menus {
        width: 100%;
        text-align: center;
        margin-top: 27px;
        position: relative;
        z-index: 999;
        img {
            width: 100%;
        }
        .experienceCon__mainCon {
            margin: 0 auto;
            display: inline-block;
            .menuItem--body1 {
                width: 140.5px;
                display: inline-block;
                position: relative;
                margin-right: -5px;
                cursor: pointer;
                height: 273px;
                border: 1px solid #808080;
                float: left;
                .menuItem--menu {
                    width: 100%;
                    
                }
                .menuItem--main {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: rgba(0,0,0,.8);
                    .menuItem--mainCon {
                        width: 100%;
                        text-align: center;
                        padding-top: 64px;
                        .menuItem--mainPic {
                            width: 37px;
                            height: 30px;
                            margin: 0 auto;
                            margin-bottom: 34px;
                            .unactiveImg {
                                display: block;
                            }
                            .activeImg {
                                display: none;
                            }
                        }
                        .menuItem--mainTxtB {
                            color: #fff;
                            font-size: 18px;
                            font-weight: bold;
                            margin-bottom: 8px;
                        }
                        .menuItem--mainTxtS {
                            color: #fff;
                            font-size: 18px;
                            font-weight: bold;
                        }
                    }
                }
                .active {
                    background: rgba(251,195,0,.9) !important;
                    p {
                        color: #333 !important;
                    }
                    .menuItem--mainCon .menuItem--mainPic {
                        .unactiveImg {
                            display: none;
                        }
                        .activeImg {
                            display: block;
                        }
                    }
                }
                .menuItem--border {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 111;
                    display: none;
                }
                &.body1Active {
                    width: 200px;
                    .menuItem--border {
                        display: block;
                    }
                }
            }
        }
    }

    .content_eight {
        position: fixed;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        box-shadow: 0 0 8px rgba(0,0,0,.4);
        .poi_nav_box {
            position: relative;
            z-index: 100;
            width: 1090px;
            height: 80px;
            margin: 0 auto;
            table {
                border-collapse: collapse;
                table-layout: fixed;
                height: 80px;
                td {
                    font-size: 16px;
                    font-weight: 600;
                    text-align: center;
                    vertical-align: middle;
                    cursor: pointer;
                    width: 155.714px;
                    -webkit-transition: background-color .5s,color .5s;
                }
                .current, td:hover {
                    color: #fff;
                    background-color: #29e;
                }
            }
        }
    }
}

.royal-experience-content {
    .experienceCon__menus {
        .experienceCon__mainCon {
            margin: -90px auto 0;
        }
    }
}
</style>